<template>
  <div class="pop-content">
    <span class="pop-title">Filter by name</span>
    <ion-list>
      <template v-for="(idx,i) in filtersIndexPop">
        <ion-item :key="'pop-indices-'+i" lines="none">
          <ion-label>{{ i }}</ion-label>
          <ion-checkbox
            slot="end"
            @ionChange="filtersIndexPop[i] = !filtersIndexPop[i]"
            :checked="filtersIndexPop[i]"
          >
          </ion-checkbox>
        </ion-item>
      </template>
    </ion-list>
    <!--
    <span class="pop-title">Filter by Ref</span>
    <ion-list>
      <ion-item lines="none">
        <input type="text" v-model="filterRefPop">
      </ion-item>
    </ion-list>
    <span class="pop-title">Filter by Cod</span>
    <ion-list>
      <ion-item lines="none">
        <input type="text" v-model="filterCodPop">
      </ion-item>
    </ion-list>
  -->
    <span class="pop-title">Filter by color</span>
    <div class="pop-light-wrapper light-wrapper">
      <div @click="filtersColorPop.green = !filtersColorPop.green" class="light green" :class="filtersColorPop.green ? 'is-active' : ''"></div>
      <div @click="filtersColorPop.yellow = !filtersColorPop.yellow" class="light yellow" :class="filtersColorPop.yellow ? 'is-active' : ''"></div>
      <div @click="filtersColorPop.red = !filtersColorPop.red" class="light red" :class="filtersColorPop.red ? 'is-active' : ''"></div>
      <div @click="filtersColorPop.nocolor = !filtersColorPop.nocolor" class="light nocolor" :class="filtersColorPop.nocolor ? 'is-active' : ''"></div>
    </div>
    <div class="pop-btn">
      <ion-button color="primary" expand="block" @click="filter">Filter</ion-button>
    </div>
  </div>
</template>

<script>
// import axios from "axios"
// import Vue from "vue"
export default {
  name: "PopoverFilters",
  props: {
    filtersIndex: { type: Object, default: () => {} },
    filtersColor: { type: Object, default: () => {} },
    filterCod: { type: String, default: '' },
    filterRef: { type: String, default: '' },
  },
  data: function() {
    return {
      filtersIndexPop: {},
      filtersColorPop: {},
      filterCodPop: {},
      filterRefPop: {},
    }
  },
  methods: {
    filter: function(success) {
      let response = {
        success,
        filtersIndex: this.filtersIndexPop,
        filtersColor: this.filtersColorPop,
        filterCod: this.filterCodPop,
        filterRef: this.filterRefPop,
      };
      this.$ionic.popoverController.dismiss(response);
    }
  },
  created: function() {
    this.filtersIndexPop = JSON.parse(JSON.stringify(this.filtersIndex))
    this.filtersColorPop = JSON.parse(JSON.stringify(this.filtersColor))
    this.filterCodPop = JSON.parse(JSON.stringify(this.filterCod))
    this.filterRefPop = JSON.parse(JSON.stringify(this.filterRef))
  },
  mounted: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pop-content {
  margin-top: 20px;
  text-align: left;
}

.pop-title {
  padding: 0 15px;
}

.pop-btn {
  padding: 0 12px 10px;
}

.pop-light-wrapper {
  padding: 10px 12px 20px;
}

.pop-light-wrapper > div {
  cursor: pointer;
}
</style>